import { Component, Inject, Optional } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogClose,
} from '@angular/material/dialog';

import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

export interface CancelDialogLabels {
  messages: string[];
  icon?: string;
  buttonLabels: {
    confirm: string;
    cancel: string;
  };
}

@Component({
  selector: 'qa-cancel-confirmation',
  templateUrl: './cancel-confirmation.component.html',
  styleUrls: ['./cancel-confirmation.component.scss'],
  imports: [MatIcon, MatButton, MatDialogClose],
})
export class CancelConfirmationComponent {
  constructor(
    @Optional() public dialogRef: MatDialogRef<CancelConfirmationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: CancelDialogLabels
  ) {}

  confirm() {
    this.dialogRef.close(true);
  }
}
